import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetMemberPrimaryTeamSuspenseQuery = () => {
    const client = useAiApiClient();

    return useSuspenseQuery({
        queryKey: AiQueryKeys.GetMemberPrimaryTeam(),
        queryFn: async () => {
            const data = await client.getMemberPrimaryTeam();

            return data.primaryTeamName ?? null;
        }
    });
};
